import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DetailApplicationService } from '../../../../service/detail-application.service';
import { TASK_ASSIGN_DISPLAY_TABLE } from '../constant/task-assign-table';

@Component({
  selector: 'app-display-task',
  templateUrl: './display-task.component.html',
  styleUrls: ['./display-task.component.scss']
})
export class DisplayTaskComponent implements OnInit {
  @Input() vendorInfoData = {};
  @Input() appAppointStatus: boolean = false;
  @Input() appointEditStatus: boolean = false;
  @Input() electromechanical: boolean;
  @Input() civilEngineering: boolean;
  @Input() getAssignPhone: string;
  activeTable = {
    "civil": true,
    "electro": true,
  };
  tableTitle = [...TASK_ASSIGN_DISPLAY_TABLE];
  assignPhone: string;
  // getAssignPhone: string;
  civlOrElectroInfo = [];

  constructor(
    private detailApplicationService: DetailApplicationService,
    private translateService: TranslateService
  ) { }

  async ngOnInit(): Promise<void> {
    // do something
  }

  ngOnChanges(changes: SimpleChanges) {
    this.civlOrElectroInfo = [];
    if (this.civilEngineering) {
      this.civlOrElectroInfo.push({ "text": this.translateService.instant('DetailInfo.CIVIL'), "value": "civil" });
    }
    if (this.electromechanical) {
      this.civlOrElectroInfo.push({ "text": this.translateService.instant('DetailInfo.ELECTRO'), "value": "electro" });
    }
  }
  async nzInputChanged(phone) {
    this.assignPhone = phone;
    this.detailApplicationService.sendAssignPhoneData.next(phone);
  }
}
